<template>
  <base-interpolator :content="text.replaceAll(id, `{${id}}`)">
    <template #[id]>
      <vf-link data-product-barcode-link :to="`#${dialogOptions.type}=barcode_${productId}`">
        {{ id }}
      </vf-link>
    </template>
  </base-interpolator>
</template>

<script lang="ts" setup>
const { text } = defineProps<{
  text: string
}>()
const config = useAppConfig()
const { dialogOptions } = config.components.dialog.default
const { enableColorAsAttribute } = config.pages.pdp
const { productId } = usePdp()
const color = useRouteQuery('color')

const id = computed(() => enableColorAsAttribute && color.value && text.includes(color.value.toString())
  ? `${productId.value}${color.value}`
  : productId.value)
</script>
